import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Sidebar.css';

const Sidebar = ({ 
  categories, 
  selectedCategory, 
  selectedSubCategory, 
  onSelectCategory, 
  onSelectSubCategory, 
  mobileMenuOpen = false, 
  setMobileMenuOpen = () => {} 
}) => {
  const { t } = useTranslation();
  const sidebarRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  
  const handleCategoryClick = (categoryId) => {
    onSelectCategory(categoryId);
    onSelectSubCategory(null);
    // Не закрываем меню на мобильных, чтобы можно было выбрать подкатегорию
    // setMobileMenuOpen(false);
  };

  const handleSubCategoryClick = (subCatCode) => {
    onSelectSubCategory(subCatCode);
    setMobileMenuOpen(false);
  };

  const handleAllProductsClick = () => {
    onSelectCategory(null);
    onSelectSubCategory(null);
    setMobileMenuOpen(false);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    // Swipe left to close (from right to left)
    if (touchStartX.current - touchEndX.current > 50) {
      setMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    const sidebar = sidebarRef.current;
    if (sidebar && mobileMenuOpen) {
      sidebar.addEventListener('touchstart', handleTouchStart);
      sidebar.addEventListener('touchmove', handleTouchMove);
      sidebar.addEventListener('touchend', handleTouchEnd);

      // Prevent body scroll when menu is open
      document.body.style.overflow = 'hidden';

      return () => {
        sidebar.removeEventListener('touchstart', handleTouchStart);
        sidebar.removeEventListener('touchmove', handleTouchMove);
        sidebar.removeEventListener('touchend', handleTouchEnd);
        document.body.style.overflow = 'unset';
      };
    } else {
      document.body.style.overflow = 'unset';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileMenuOpen]);

  return (
    <>
      {/* Mobile Filter Button */}
      <button 
        className="mobile-filter-button"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.5 5.83333H9.16667M9.16667 5.83333C9.16667 7.214 10.286 8.33333 11.6667 8.33333C13.0473 8.33333 14.1667 7.214 14.1667 5.83333M9.16667 5.83333C9.16667 4.45267 10.286 3.33333 11.6667 3.33333C13.0473 3.33333 14.1667 4.45267 14.1667 5.83333M14.1667 5.83333H17.5M2.5 14.1667H5.83333M5.83333 14.1667C5.83333 15.5473 6.95267 16.6667 8.33333 16.6667C9.714 16.6667 10.8333 15.5473 10.8333 14.1667M5.83333 14.1667C5.83333 12.786 6.95267 11.6667 8.33333 11.6667C9.714 11.6667 10.8333 12.786 10.8333 14.1667M10.8333 14.1667H17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        {t('categories', 'Categories')}
      </button>

      {/* Overlay for mobile */}
      {mobileMenuOpen && <div className="mobile-overlay" onClick={() => setMobileMenuOpen(false)} />}

      {/* Sidebar */}
      <aside 
        ref={sidebarRef}
        className={`sidebar ${mobileMenuOpen ? 'mobile-open' : ''}`}
      >
        <div className="sidebar-header">
          <h3>{t('categories', 'Categories')}</h3>
          <button 
            className="mobile-close-button"
            onClick={() => setMobileMenuOpen(false)}
          >
            ✕
          </button>
        </div>
        
        <div className="categories-list">
          <button
            className={`category-item ${!selectedCategory ? 'active' : ''}`}
            onClick={handleAllProductsClick}
          >
            {t('allProducts', 'All products')}
          </button>

          {categories.map((category) => (
            <div key={category._id} className="category-group">
              <button
                className={`category-item ${selectedCategory === category._id && !selectedSubCategory ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category._id)}
              >
                <span className="category-code">{category.code}</span>
                {t(category.code, category.name)}
              </button>

              {selectedCategory === category._id && category.subCategories?.length > 0 && (
                <div className="subcategories-list">
                  {category.subCategories.map((subCat) => (
                    <button
                      key={subCat._id}
                      className={`subcategory-item ${selectedSubCategory === subCat.code ? 'active' : ''}`}
                      onClick={() => handleSubCategoryClick(subCat.code)}
                    >
                      <span className="subcategory-code">{subCat.code}</span>
                      {t(subCat.code, subCat.name)}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </aside>
    </>
  );
};

export default Sidebar;

